// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C1AoE","placeholdersHeader":"styles_placeholdersHeader__2sUKr","editorStyle":"styles_editorStyle__3lf_r","placeholdersBox":"styles_placeholdersBox__dUVnh"};